export const setLeitoTransferencia = (state, payload) => {
    state.leitoTransferencia = payload;
}